import prepareDetails from '../helpers/prepareDetails';
import axios from './axios';
import sampleGrid from '../sampleGrid';

class Collections {

    addComment = async (collectionId, comment) => {
        const response = await axios.put(`Collections/comments/add`, { collectionId, comment })
        return response.data
    }

    getVarianceHistory = async (operatorId, siteId, option) => {
        const response = await axios.get(`Collections/variancehistory/${operatorId},${siteId},${option}`)
        return response.data;
    }

    getVarianceHistoryByMin = async (operatorId, min) => {
        const response = await axios.get(`collections/variancehistorybymin/${operatorId},${min}`);
        return response.data;
    }

    getVarianceHistoryExport = async (operatorId, siteId, option) => {
        const response = await axios.get(`Collections/variancehistory/export/${operatorId},${siteId},${option}`, { responseType: 'arraybuffer'})
        return response;
    }

    getVarianceHistoryOptions = async (operatorId, siteId) => {
        const response = await axios.get(`Collections/variancehistory/options/${operatorId},${siteId}`)
        return response.data;
    }

    getCommentsByCollection = async (collectionId) => {
        const response = await axios.get(`Collections/comments/bycollection/${collectionId}`)
        return response.data;
    }

    getComments = async (operatorId, siteId, periodId) => {
        const response = await axios.get(`Collections/comments/${operatorId},${siteId},${periodId}`)
        return response.data;
    }

    getPeriods = async (operatorId, siteId) => {
        const response = await axios.get(`Collections/banking/week/periods/${operatorId},${siteId}`)
        return response.data;
    }

    getBankingWeek = async (operatorId, siteId, fromId, toId) => {
        const response = await axios.get(`Collections/banking/week/${operatorId},${siteId},${fromId},${toId}`);
        return response.data;
    }

    getBankingWeekExport = async (operatorId, siteId, fromId, toId) => {
        const response = await axios.get(`Collections/banking/week/export/${operatorId},${siteId},${fromId},${toId}`, { responseType: 'arraybuffer' });
        return response;
    }

    getBankingWeekByEgm = async (detailRef) => {
        const response = await axios.get(`Collections/banking/week/byEGM/${detailRef}`);
        return response.data;
    }

    getBankingWeekTransactions = async (CollectionId, details) => {
        const response = await axios.put(`Collections/banking/week/byEGM/transactions/filter`, { CollectionId, Details: prepareDetails(details) });
        return response.data;
    }

    getBankingPerformance = async (operatorId, siteId, fromId, toId) => {
        const response = await axios.get(`Collections/performance/week/${operatorId},${siteId},${fromId},${toId}`);
        return response.data;
    }

    getBankingPerformanceExport = async (operatorId, siteId, fromId, toId) => {
        const response = await axios.get(`Collections/performance/week/export/${operatorId},${siteId},${fromId},${toId}`, { responseType: 'arraybuffer' });
        return response;
    }

    getBankingWeekDetail = async (operatorId, siteId, periodId) => {
        const response = await axios.get(`Collections/banking/week/detail/${operatorId},${siteId},${periodId}`);
        return response.data;
    }

    getBankingPerformanceDetail = async (operatorId, siteId, periodId) => {
        const response = await axios.get(`Collections/performance/week/detail/${operatorId},${siteId},${periodId}`);
        return response.data
    }


    getBankingPerformance = async (operatorId, siteId, fromId, toId) => {
        const response = await axios.get(`Collections/performance/week/${operatorId},${siteId},${fromId},${toId}`);
        return response.data;
    }

    getBankingWeekDetail = async (operatorId, siteId, periodId) => {
        const response = await axios.get(`Collections/banking/week/detail/${operatorId},${siteId},${periodId}`);
        return response.data;
    }

    getBankingPerformanceDetail = async (operatorId, siteId, periodId) => {
        const response = await axios.get(`Collections/performance/week/detail/${operatorId},${siteId},${periodId}`);
        return response.data;
    }

    getBankingPerformanceByEgm = async (detailRef) => {
        const response = await axios.get(`Collections/performance/week/byEGM/${detailRef}`);
        return response.data;
    }

    getMachinePerformancePdf = async (batchId) => {
        const response = await axios.get(`Report/Collection/Batch/Performance/Analysis/PDF/${batchId}`, { responseType: 'arraybuffer' });
        return response;
    }

    getMachinePerformanceCsv = async (batchId) => {
        const response = await axios.get(`Report/Collection/Batch/Performance/Analysis/CSV/${batchId}`, { responseType: 'arraybuffer' });
        return response;
    }

    getBankingSummaryPdf = async (batchId) => {
        const response = await axios.get(`Report/Collection/Batch/Banking/Summary/PDF/${batchId}`, { responseType: 'arraybuffer' });
        return response;
    }

    getBankingVariancePdf = async (batchId) => {
        const response = await axios.get(`Report/Collection/Batch/Banking/Variance/PDF/${batchId}`, { responseType: 'arraybuffer' });
        return response;
    }

    getPerformanceSummaryPdf = async (batchId) => {
        const response = await axios.get(`Report/Collection/Batch/Performance/Summary/PDF/${batchId}`, { responseType: 'arraybuffer' });
        return response;
    }

    getPerformanceVariancePdf = async (batchId) => {
        const response = await axios.get(`Report/Collection/Batch/Performance/Variance/PDF/${batchId}`, { responseType: 'arraybuffer' });
        return response;
    }
    
    editMeter = async (meterRef) => {
        const response = await axios.get(`Collections/meter/edit/${meterRef}`);
        return response.data;
    }

    updateMeter = async (meterRef, details) => {
        const response = await axios.put(`Collections/meter/update`, { meterRef, complete: true, details: prepareDetails(details) });
        return response.data;
    }

    refreshMeter = async (detailRef) => {
        const response = await axios.get(`Collections/banking/week/byEGM/Meters/${detailRef}`);
        return response.data;
    }

    getPromoCashDetails = async (siteId) => {
        return sampleGrid.grid; 
    }
}

export default new Collections();